// Module
var code = `<div class="center-header box" ng-if="\$ctrl.center">

  <div class="center-header__section center-header__section--bigger">
    <span class="title">Name:</span>
    <span class="value trim" title="{{\$ctrl.center.name}}">
      {{\$ctrl.center.name}}
    </span>
  </div>

  <div class="center-header__section center-header__section--smaller">
    <span class="title">Reference no.:</span>
    <span class="value">{{\$ctrl.center.id}}</span>
  </div>

  <div class="center-header__section center-header__section--smaller">
    <span class="title">Branch:</span>
    <span class="value">{{\$ctrl.centerBranchName}}</span>
  </div>

  <div class="center-header__section center-header__section--smaller">
    <span class="title">Status:</span>
    <span class="value">{{\$ctrl.center.active ? 'Active' : 'Inactive'}}</span>
  </div>

  <button
    type="button"
    class="btn btn-primary open-link"
    ng-click="\$ctrl.activateCenter()"
    ng-if="\$ctrl.center && !\$ctrl.center.active && !\$ctrl.isFormInputEnabled()"
    command-access="ActivateCenter"
  >
    Activate
  </button>
  <button
    type="button"
    class="btn open-link"
    ng-click="\$ctrl.deactivateCenter()"
    ng-if="\$ctrl.center && \$ctrl.center.active && !\$ctrl.isFormInputEnabled()"
    command-access="DeactivateCenter"
  >
    Deactivate
  </button>
  <button
    type="button"
    command-access="DeleteCenter"
    class="btn btn-danger open-link"
    ng-click="\$ctrl.deleteCenter()"
    ng-disabled="!\$ctrl.center.active"
    ng-if="!\$ctrl.isFormInputEnabled()"
  >
    Delete
  </button>

</div>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/center/header/center-header.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;